import { STORAGE_KEYS } from '../../utils/constantes';

export function setToken(token){
    localStorage.setItem(STORAGE_KEYS.TOKEN, token)
}


export function getToken(){
    return localStorage.getItem(STORAGE_KEYS.TOKEN);
}


export function removeToken(){
    localStorage.removeItem(STORAGE_KEYS.TOKEN)
}